export const ENV = {
  // apiAmbly: "http://localhost:8030",
  apiAmbly: "https://api.ambly.co",
  apiIp: "https://api.ipify.org/?format=json",
};
